import React from 'react';

import { Suppliers as SuppliersView } from '@silvertours/common-landingpages-view';
import { UiLegacy } from '@silvertours/front-legacy-shared';
import { LayoutLegacy } from '@silvertours/front-legacy-entities';

import { SupplierList, SupplierListItem } from './Stage.styles';

type SuppliersProps = {
  suppliers?: SuppliersView;
};

const Suppliers = ({ suppliers }: SuppliersProps) => {
  if (!suppliers || suppliers.length === 0) {
    return null;
  }

  return (
    <LayoutLegacy.PlainSegment id="suppliers">
      <SupplierList>
        {suppliers.map(({ id }) => (
          <SupplierListItem key={id}>
            <UiLegacy.ImageSVG name={id} />
          </SupplierListItem>
        ))}
      </SupplierList>
    </LayoutLegacy.PlainSegment>
  );
};

export { Suppliers };
export type { SuppliersProps };
